export class Usuario {
  nombres: string;
  apellidos: string;
  rutaprofileImg: string;
  nameInternoImg: string;
  userId: string;
  documentID: string;
  perfil: string;
  calificacion: number;
}
